import { Button } from "@chakra-ui/react";
import React from "react";

function CustomCheckbox(props) {
    const { value, label, isChecked, onChange, colorScheme, disabled } = props;
    return (
        <Button
            ml='1'
            backgroundColor={isChecked ? (colorScheme ? colorScheme : "red.500") : "transparent"}
            border={isChecked ? null : "0.2px solid #4A5568"}
            onClick={() => onChange(!isChecked)}
            whiteSpace="normal"
            textAlign="center"
            padding="3px" 
            fontSize="sm" 
            disabled={disabled || false}
        >
            {label}
        </Button>
    );
};

export default CustomCheckbox;